var React = require('react');

function IcNavPosters (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.5 7C5.88071 7 7 5.88071 7 4.5S5.88071 2 4.5 2 2 3.11929 2 4.5 3.11929 7 4.5 7zM5 17V8.97254C7.08581 8.74196 8.74196 7.08581 8.97254 5H19v4.15385L14.5 14l-4-2.5L5 17zm-2 2V8.74394C1.25221 8.12619 0 6.45933 0 4.5 0 2.01472 2.01472 0 4.5 0c1.95933 0 3.62619 1.25221 4.24394 3H21v19H3v-3z","fill":"currentColor"}));
}

IcNavPosters.defaultProps = {"fill":"none","viewBox":"0 0 21 22"};

module.exports = IcNavPosters;

IcNavPosters.default = IcNavPosters;
